<template>
  <label
    class="flex items-center gap-3 rounded-2xl border border-slate-200 p-3"
  >
    <input
      :checked="modelValue"
      type="checkbox"
      class="h-5 w-5 rounded border-slate-300"
      @change="onChange"
    />
    <span class="text-xs font-semibold text-slate-700"
      ><slot>{{ label }}</slot></span
    >
  </label>
</template>

<script lang="ts">
export default {
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  setup(_: any, { emit }: any) {
    const onChange = (event: Event) =>
      emit("update:modelValue", (event.target as HTMLInputElement).checked);
    return { onChange };
  },
};
</script>
